<template>
  <div class="examine">
    <div class="top wbg" v-if="$common.AUTH('info:audit:lists')">
      <a-form-model ref="ruleForm" :model="form" style="display: flex;">
        <a-row class="row">
          <a-col class="flex" :span="4">
            <label>被告姓名：</label>
            <a-input v-model="form.debtor_realname" placeholder="请输入被告姓名"></a-input>
          </a-col>
          <a-col class="flex" :span="5">
            <label>证件号码：</label>
            <a-input v-model="form.debtor_chinaid" placeholder="请输入证件号码"></a-input>
          </a-col>
          <a-col class="flex" :span="6">
            <label>发起时间：</label>
            <timePick @PickTime="PickTime"></timePick>
          </a-col>
          <a-col class="flex">
            <label>审核状态：</label>
            <a-select v-model="form.status" placeholder="请选择" class="select">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="1">待审核</a-select-option>
              <a-select-option value="2">生效</a-select-option>
              <a-select-option value="3">驳回</a-select-option>
            </a-select>
          </a-col>
          <a-col class="flex">
            <label>操作类型：</label>
            <a-select v-model="form.mySelf" placeholder="请选择" class="select">
              <a-select-option :value="1">我发起的</a-select-option>
              <a-select-option :value="0">我审核的</a-select-option>
            </a-select>
          </a-col>
          <a-col class="flex">
            <a-button icon="search" @click="type = 0; query(1)" type='primary' style="height:32px;">查询</a-button>
            <a-button @click="overQ" style='margin-left:10px;height:32px;' class="blu"
              :class="{ aac: type == 2 }">累计未审核({{ nolist }})</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <div class="tcon wbg">
      <div class="tableList" v-if="$common.AUTH('info:audit:lists')">
        <a-table rowKey="id" :columns="columns" :data-source="data" :customRow="dbclick" :pagination="page"
          @change="query">
          <div slot="create_time" slot-scope="text, record">
            <span v-if="record.create_time">{{
              new Date(record.create_time)
              | parseTime('{y}-{m}-{d} {h}:{i}:{s}')
              }}</span>
          </div>
          <div slot="user" slot-scope="text, record">
            <span class="curpoter" @click="link(record)">
              {{ record.user.uname }}</span>
          </div>
          <div slot="update_time" slot-scope="text, record">
            <span v-if="record.update_time && record.status != 1">{{
              new Date(record.update_time)
              | parseTime('{y}-{m}-{d} {h}:{i}:{s}')
              }}</span>
          </div>
          <div slot="nickName" slot-scope="text, record">
            <span class="curpoter" @click="link(record)">{{
              record.manager.uname
              }}</span>
          </div>
          <div slot="belong" slot-scope="text, record">
            <Normap :Wid="200" :tit="record.belong">{{ record.belong }}</Normap>
          </div>
          <div slot="action" slot-scope="text, record">
            {{ record.action == 'edit' ? '修改' : record.action == 'add' ? '新增' : '删除' }}
          </div>
          <div slot="status" slot-scope="text, record">
            <span v-if="record.status === 3" :style="'color: ' + status[record.status].color">
              <a-popover :content="record.reason">
                <div class="norTie">驳回</div>
              </a-popover>
            </span>
            <span v-else :style="'color: ' + status[record.status].color">{{
              status[record.status].name
              }}</span>
          </div>
          <div slot="content" slot-scope="text, record">
            <Normap :Wid="220" :tit="record.content">{{ record.content }}
            </Normap>
          </div>
          <div slot="alist" slot-scope="text, record">
            <!-- <template v-if="$common.AUTH('2-1')">
                <router-link v-if="record.debtor_id>0 && record.loan_id<=0" :to='{"name":"lydetails",params:{"id":record.debtor_id},query:{t:1}}'>查看</router-link>
                <router-link v-else :to="{ name: 'paybacksee', params: { id: record.loan_id ,query:{t:1}} }">查看</router-link>
            </template>-->
            <template v-if="record.status === 1">
              <!-- <span class="line"></span> -->
              <a href="javascript:void(0);" @click="examineClick(record.id, record.action)">审核</a>
            </template>
          </div>
        </a-table>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>

    <a-modal v-model="modalVisible" title="选择审核结果" width="325px" centered
      @cancel="examineForm.status = 2; examineForm.reason = '';">
      <div class="change-examine">
        <a-form-model ref="ruleForm" :model="examineForm" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
          <a-form-model-item label="选择审核结果" prop="status" style="margin-bottom: 10px">
            <a-radio-group v-model="examineForm.status" name="status" :default-value="1">
              <a-radio :value="2">同意</a-radio>
              <a-radio :value="3">驳回</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div class="remark" v-if="examineForm.status == 3">
            <p style="margin-bottom: 5px"> 驳回原因</p>
            <a-input type="textarea" v-model="examineForm.reason" placeholder="请输入驳回原因" style="width: 100%"></a-input>
          </div>
        </a-form-model>
      </div>
      <div slot="footer" class="modal-footer">
        <a-popconfirm title="删除后无法恢复，是否确认删除?" ok-text="确定" cancel-text="取消" @confirm="examineConfirm"
          v-if='dislogType == "del" && examineForm.status == 2'>
          <a-button type="primary">提交</a-button>
        </a-popconfirm>
        <a-button type="primary" @click="examineConfirm" v-else>提交</a-button>
        <a-button type="primary" class="cancel"
          @click="examineForm.status = 2; examineForm.reason = ''; modalVisible = false">取消</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import {
  getAudit,
  auditCheck
} from '@/server/audit'
const columns = [{
  title: '操作时间',
  key: 'create_time',
  dataIndex: 'create_time',
  scopedSlots: {
    customRender: 'create_time'
  },
  width: 180,
},
{
  title: '操作人',
  key: 'user',
  dataIndex: 'user',
  scopedSlots: {
    customRender: 'user'
  },
  width: 80,
},
{
  title: '审核时间',
  key: 'update_time',
  dataIndex: 'update_time',
  scopedSlots: {
    customRender: 'update_time'
  },
  width: 180,
},
{
  title: '审核人',
  key: 'nickName',
  dataIndex: 'nickName',
  scopedSlots: {
    customRender: 'nickName'
  },
  width: 100,
},
{
  title: '所属',
  key: 'belong',
  dataIndex: 'belong',
  scopedSlots: {
    customRender: 'belong'
  },
  width: 180,
},
{
  title: '操作类型',
  key: 'action',
  dataIndex: 'action',
  scopedSlots: {
    customRender: 'action'
  },
  width: 100,
},
{
  title: '状态',
  key: 'status',
  dataIndex: 'status',
  scopedSlots: {
    customRender: 'status'
  },
  width: 80,
},
{
  title: '详情',
  key: 'content',
  dataIndex: 'content',
  scopedSlots: {
    customRender: 'content'
  },
  width: 240,
},
{
  title: '操作',
  key: 'alist',
  dataIndex: 'alist',
  scopedSlots: {
    customRender: 'alist'
  },
  width: 60,
},
]
import {
  yearFormats
} from '@/assets/js/formData'
export default {
  data() {
    return {
      dislogType: 'add', //弹窗类型
      modalVisible: false,
      examineForm: {
        id: '',
        status: 2,
        reason: '',
      },
      type: 0,
      selectedRowKeys: [],
      nolist: 0,
      noThe: 0,
      form: {
        debtor_chinaid: '',
        debtor_realname: '',
        stime: '',
        etime: '',
        status: '',
        mySelf: 0,
      },
      time: [],
      columns,
      type: {
        1: '修改信息',
        2: '删除',
        3: '申请执行',
        4: '删除附件',
      },
      status: {
        1: {
          name: '待审核',
          color: '#FF7831',
        },
        2: {
          name: '生效',
          color: '#12B216',
        },
        3: {
          name: '驳回：',
          color: '#FF2C2C',
        },
      },
      data: [],

      page: {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showLessItems: true,
        showSizeChanger: false,
        total: 0,
        showTotal(total) {
          return `小计 ${total} `
        },
      },
      groupData: this.$store.state.user ?
        this.$store.state.user.link_group :
        [],
    }
  },
  computed: {
    hasSelected() {
      // return this.selectedRowKeys.length > 0;
    },
  },
  created() {
    this.seeNotype()
    this.query()
    if (this.$route.query.see) {
      this.form.status = '1'
      this.query(1)
    }
  },
  mounted() {
    let _this = this
    document.onkeydown = function (e) {
      if (e.keyCode == 13) {
        _this.query()
        _this.seeNotype()
      }
    }
  },
  methods: {
    overQ() {
      this.type = 2
      this.form.status = '1'
      this.time = []
      this.form.stime = ''
      this.form.etime = ''
      this.query(1)
    },
    searchNo() {
      this.type = 1
      this.form.status = '1'
      this.time = [this.getPreDay().stime, this.getPreDay().etime]
      this.form.stime = this.getPreDay().stime
      this.form.etime = this.getPreDay().etime
      this.query(1)
    },
    getPreDay() {
      let d = new Date().getTime(),
        prev = d - 24 * 60 * 60 * 1000 * 2
      return {
        etime: yearFormats(d),
        stime: yearFormats(prev),
      }
    },
    seeNotype() {
      getAudit({
        status: 1,
        page: 1,
        limit: 1,
      }).then((res) => {
        this.nolist = res.count
      })
      getAudit({
        status: 1,
        page: 1,
        limit: 1,
        stime: this.getPreDay().stime,
        etime: this.getPreDay().etime,
      }).then((res) => {
        this.noThe = res.count
      })
    },
    dbclick(record) {
      return {
        on: {
          // 事件
          dblclick: (event) => {
            if (record.debtor_id > 0 && record.loan_id <= 0) {
              if (this.$common.AUTH('debtor:info')) {
                //     this.$router.push({ "name": "lydetails", params: { "id": record.debtor_id }, query: { t: 1 } })
                let routeUrl = this.$router.resolve({
                  name: 'lydetails',
                  params: {
                    id: record.debtor_id
                  },
                  query: {
                    t: 1
                  },
                })
                window.open(routeUrl.href, '_blank')
              } else {
                this.$message.error('暂无权限')
              }
            } else {
              if (this.$common.AUTH('loan:info:lists')) {
                //     this.$router.push({ name: 'paybacksee', params: { id: record.loan_id, query: { t: 1 } } })
                let routeUrl = this.$router.resolve({
                  name: 'paybacksee',
                  params: {
                    id: record.loan_id,
                    query: {
                      t: 1
                    }
                  },
                })
                window.open(routeUrl.href, '_blank')
              } else {
                this.$message.error('暂无权限')
              }
            }
          },
        },
      }
    },
    link(record) {
      if (record.debtor_id > 0 && record.loan_id <= 0) {
        if (this.$common.AUTH('debtor:info')) {
          let routeUrl = this.$router.resolve({
            name: 'lydetails',
            params: {
              id: record.debtor_id
            },
            query: {
              t: 1
            },
          })
          window.open(routeUrl.href, '_blank')
          // this.$router.push({ "name": "lydetails", params: { "id": record.debtor_id }, query: { t: 1 } })
        } else {
          this.$message.error('暂无权限')
        }
      } else {
        if (this.$common.AUTH('loan:info:lists')) {
          //    this.$router.push({ name: 'paybacksee', params: { id: record.loan_id, query: { t: 1 } } })
          let routeUrl = this.$router.resolve({
            name: 'paybacksee',
            params: {
              id: record.debtor_id,
              query: {
                t: 1
              }
            },
          })
          window.open(routeUrl.href, '_blank')
        } else {
          this.$message.error('暂无权限')
        }
      }
    },
    PickTime(e) {
      if ('stime' in e) {
        this.form.stime = e.stime
      } else {
        this.form.etime = e.etime
      }
    },
    query(val) {
      if (val) {
        if (typeof val === 'object') {
          this.page.current = val.current
          this.page.pageSize = val.pageSize
        } else {
          this.page.current = 1
        }
      }
      let obj = Object.assign({
        page: this.page.current,
        limit: this.page.pageSize,
      },
        this.form
      )
      getAudit(obj).then((res) => {
        res.list.map((ele) => {
          if (!ele.manager) {
            ele.manager = {
              uname: '',
            }
          }
        })
        this.data = res.list
        this.page.total = res.count
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    examineConfirm() {
      if (!this.examineForm.reason && this.examineForm.status == 3) {
        this.$message.error('请填写驳回原因')
        return false
      }
      auditCheck(this.examineForm).then((res) => {
        this.$message.success({
          content: '审核成功'
        })
        this.query()
        this.modalVisible = false
      })
    },
    examineClick(id, type) {
      this.dislogType = type
      this.modalVisible = true
      this.examineForm.id = id
    },
  },
}
</script>
<style lang="less" scoped>
.examine {
  padding-bottom: 50px;
  @import url('@/assets/css/search.less');

  .top {
    padding: 20px;

    .to {
      display: inline-block;
      width: 20px;
      height: 1px;
      margin: 0 10px;
      background-color: #dbdcde;
      vertical-align: middle;
    }

    form {
      width: 100%;
    }

    .btns {
      float: right;

      button {
        margin-left: 20px; // width: 90px;
      }

      .aac {
        border-color: #1d8bfe !important;
        color: #fff !important;
        background: #1d8bfe;
      }
    }
  }
}

.ant-btn {
  // border-color: #1d8bfe;
  // color: #1d8bfe;
}

.ant-btn-primary {
  color: #ffffff;
  border-color: #1d8bfe;
  background-color: #1d8bfe;
}

.tcon {
  padding: 0 20px 20px;
  min-height: 760px;

  .tableList {
    .line {
      display: inline-block;
      width: 1px;
      height: 14px;
      background-color: #dbdcde;
      margin: 0 10px;
      vertical-align: middle;
    }
  }
}

/deep/ .ant-modal-header {
  padding: 20px 40px;
}

/deep/ .ant-modal-body {
  padding: 24px 40px;
}

/deep/ .ant-modal-footer {
  border-top: none;
  padding-bottom: 30px;
}

.modal-footer {
  text-align: center;

  button {
    width: 90px;
  }

  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}

@media screen and (max-width:1024px) {
  /deep/ .ant-table-body {
    overflow-x: auto;
  }
}
</style>
